<div
  class="grid grid-nogutter flex-nowrap"
  style="height: 100%">
  <div class="left-menu-wrapper">
    <div
      *ngIf="devEnvironment"
      class="dev-layout">
      <p
        *ngIf="!menuMinimized"
        class="text-4xl font-bold text-white surface-900 py-4 text-center">
        DEV-версия
      </p>
      <div
        *ngIf="menuMinimized"
        class="surface-900 py-4 text-center">
        <i class="pi pi-code text-5xl font-bold text-white"></i>
      </div>
    </div>
    <div
      class="grid-nogutter left-menu px-2"
      [class.minimized]="menuMinimized">
      <div class="toggle-menu-icon px-3 py-5 flex align-items-center justify-content-between">
        <a
          routerLink="/"
          class="flex-grow-1">
          <div
            class="w-full"
            *ngIf="!menuMinimized">
            <div class="flex justify-content-center">
              <img
                *ngIf="!globalService.globalInfo.tenantInfo?.avatar"
                alt="Логотип ФРМ"
                src="/assets/images/logo.png"
                style="height: 50px" />
              <img
                *ngIf="globalService.globalInfo.tenantInfo?.avatar"
                alt="Логотип ФРМ"
                [src]="'file/' + globalService.globalInfo.tenantInfo.avatar.path | apiUrl"
                [style.height.px]="50"
                [style.max-width.px]="120" />
            </div>
          </div>
        </a>
        <i
          class="pi {{ menuMinimized ? 'pi-angle-double-right' : 'pi-angle-double-left' }}"
          (click)="changeViewMenu()"></i>
      </div>
      <crm-menu-component [minimized]="menuMinimized"></crm-menu-component>
    </div>
  </div>
  <div
    class="left-menu-offset"
    [class.minimized]="menuMinimized"></div>
  <crm-notification-panel [minimized]="menuMinimized"></crm-notification-panel>
  <div
    class="main-content w-full pt-3 px-3 sm:px-6 sm:block"
    [class.minimized]="!menuMinimized">
    <router-outlet></router-outlet>
  </div>
</div>

<crm-form-sidebar></crm-form-sidebar>
